import get from 'lodash/get';
import classNames from 'classnames';
import React, {Component} from 'react';
import {FastField, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import {generateNextRowId} from '../../../../services/idHelpers';
import MinusButton from '../MinusButton';
import PlusButton from '../PlusButton';
import UpButton from '../UpButton';
import DownButton from '../DownButton';
import Error from '../../../Error';
import RichEditorField from '../../../rte/RichEditorField';
import TooltipIcon from '../../../TooltipIcon';
import DraggableCell from '../DraggableCell';
import DraggableRow from '../DraggableRow';
import DragDropTableBody from '../DragDropTableBody';
import {previousQuestionsSupportingExpressions} from '../../../../services/conditionBuilders';

class Rank1RowType extends Component {
    constructor(props) {
        super(props);
        this.addRow = this.addRow.bind(this);
        this.toggleShuffle = this.toggleShuffle.bind(this);
    }

    addRow() {
        const rows = get(this.props.form.values, this.props.name);
        this.props.push({id: generateNextRowId(rows), label: '', shuffle: false});
    }

    toggleShuffle() {
        const {replace, form, name} = this.props;
        const items = get(form.values, name) || [];
        const value = !items.every(({shuffle}) => shuffle);
        items.forEach((item, index) => {
            replace(index, Object.assign({}, item, {shuffle: value}));
        });
    }

    render() {
        const {remove, move, form, name, previousPages} = this.props;
        const questions = previousQuestionsSupportingExpressions(previousPages);

        const items = get(form.values, name) || [];

        return (
            <table className="table table-sm table-borderless">
                <colgroup>
                    <col style={{width: 120}} />
                    <col />
                    <col style={{width: 100}} />
                    <col style={{width: 80}} />
                    <col style={{width: 80}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className="pl-0"><FormattedMessage {...messages.surveys.form.label.id} /></th>
                        <th>
                            <FormattedMessage {...messages.surveys.form.label.text} />
                        </th>
                        <th colSpan="3">
                            <div className="custom-control custom-checkbox">
                                <input className="custom-control-input" type="checkbox"
                                    checked={items.every(({shuffle}) => shuffle)} onChange={this.toggleShuffle} id={`${name}.shuffledToggle`} />
                                <label className="custom-control-label" htmlFor={`${name}.shuffledToggle`}>
                                    <FormattedMessage {...messages.surveys.form.label.shuffled} />
                                    {' '}
                                    <TooltipIcon message={messages.surveys.form.tooltip.shuffled} />
                                </label>
                            </div>
                        </th>
                    </tr>
                </thead>
                <DragDropTableBody move={move}>
                    {items.map((item, index, arr) => (
                        <DraggableRow item={item} index={index} key={index}>
                            <DraggableCell className="pl-0">
                                <FastField id={`${name}.${index}.id`} name={`${name}.${index}.id`} type="text"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.${index}.id`) && get(form.touched, `${name}.${index}.id`)})}
                                />
                                <ErrorMessage name={`${name}.${index}.id`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </DraggableCell>
                            <DraggableCell>
                                <FastField id={`${name}.${index}.label`} name={`${name}.${index}.label`} component={RichEditorField}
                                    questions={questions}
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.${index}.label`) && get(form.touched, `${name}.${index}.label`)})}
                                />
                                <ErrorMessage name={`${name}.${index}.label`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </DraggableCell>
                            <DraggableCell>
                                <FastField name={`${name}.${index}.shuffle`}>
                                    {({field}) => (
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" name={field.name} id={`${name}.${index}.shuffle`} className="custom-control-input"
                                                checked={field.value || false} onChange={field.onChange} />
                                            <label className="custom-control-label" htmlFor={`${name}.${index}.shuffle`}>&nbsp;</label>
                                        </div>
                                    )}
                                </FastField>
                            </DraggableCell>
                            <DraggableCell className="border-right">
                                <div className="d-flex justify-content-center">
                                    <div className="flex-column">
                                        <div className="">{index > 0 && <UpButton move={move} index={index} />}</div>
                                        <div className="">{index + 1 < arr.length && <DownButton move={move} index={index} />}</div>
                                    </div>
                                </div>
                            </DraggableCell>
                            <DraggableCell>
                                <div className="d-flex justify-content-center">
                                    <div className="flex-column">
                                        <MinusButton remove={remove} index={index} />
                                    </div>
                                </div>
                            </DraggableCell>
                        </DraggableRow>
                    ))}
                </DragDropTableBody>
                <tfoot>
                    <tr>
                        <td colSpan="4" className="pl-0">
                            <PlusButton onClick={this.addRow}>
                                <FormattedMessage {...messages.surveys.button.add_row} />
                            </PlusButton>
                        </td>
                    </tr>
                </tfoot>
            </table>
        );
    }
}

export default Rank1RowType;
